import { createSelector } from 'reselect';

const getUsers = (state) => state.acl_users.items;

// expects a number as the second argument
const userId = (state, itemId) => itemId;

export const makeGetUser = () => createSelector(
  [getUsers, userId],
  (items, itemId) => items.find(u => u.id === itemId) || null
);
